/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../SVGWrapper';

function TvHeartIcon({ height = 60, width = 60 }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 70 70"
      fill="none"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.7882 23.2364C35.3669 23.7046 34.6328 23.7046 34.2115 23.2364L32.6348 21.4846C29.6581 18.1771 26.0438 17.7651 24.3938 17.7651C23.0065 17.7651 20.538 18.4128 18.4568 20.1195C16.5014 21.7228 14.8483 24.285 14.8483 28.3712C14.8483 30.0002 15.4346 31.9592 16.6676 34.2117C17.8895 36.4438 19.6442 38.7783 21.7218 41.1018C25.856 45.7251 31.0108 50.0209 35.0001 53.0446C38.9904 50.0218 44.1452 45.7316 48.2791 41.1138C50.3566 38.7932 52.111 36.4616 53.3326 34.2317C54.5652 31.9817 55.1514 30.0243 55.1514 28.3955C55.1514 24.3093 53.4982 21.7472 51.5429 20.1438C49.4616 18.4371 46.9932 17.7895 45.6059 17.7895C43.9401 17.7895 40.3345 18.185 37.3649 21.4846L35.7882 23.2364ZM32.6539 17.2447C29.4303 14.9241 26.0942 14.5833 24.3938 14.5833C20.1514 14.5834 11.6665 18.1894 11.6665 28.3712C11.6665 37.7963 24.9958 49.4632 33.1464 55.6321C34.2464 56.4646 35.7532 56.4646 36.8534 55.6323C45.0041 49.4665 58.3332 37.8206 58.3332 28.3955C58.3332 18.2137 49.8483 14.6076 45.6059 14.6076C43.903 14.6076 40.5598 14.9337 37.3321 17.257C36.539 17.8279 35.7529 18.5193 34.9998 19.356C34.2424 18.5145 33.4516 17.819 32.6539 17.2447Z" fill="white" />
    </SVGWrapper>
  );
}

export default TvHeartIcon;
